import { LoyaltyRewardsSection } from "Components/Loyalty/Shared/Rewards/LoyaltyRewardsSection";
import { LoyaltyPointType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

export const RewardsSection = () => {
  const { t } = useResource();

  return (
    <LoyaltyRewardsSection
      pointType={LoyaltyPointType.Stardust}
      pointsLabel={t(
        Resources.Pages.Content.Stardust.Rewards.Columns.PointsLabel,
      )}
    />
  );
};
